/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgToolbarUndo as ToolbarUndoSmall } from "./small/ToolbarUndo";
const sizeMap = {
    small: ToolbarUndoSmall,
};
const defaultSize = getDefaultSize(sizeMap);

export const ToolbarUndoIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
ToolbarUndoIcon.displayName = "ToolbarUndoIcon";
